import React, { SVGProps } from 'react';

import { Button, SplitButton, SplitButtonDropdownContent, SplitButtonDropdownItem } from '@mesh.ai/rabbit';

const SplitButtonAgGrid = ({
  options = [],
  buttonLabel,
  disabled,
  StartIcon,
}: Omit<SplitButtonProps, 'isSplitButton'>) => {
  const startIconExists = !!StartIcon;
  return (
    <SplitButton disabled={disabled} iconLeft={startIconExists && StartIcon}>
      {buttonLabel}
      <SplitButtonDropdownContent>
        {options.map((option, index) => {
          const { label, onClick, Icon, disabled } = option;
          return (
            <SplitButtonDropdownItem key={`split-button-option-${index}`} onSelect={onClick} disabled={disabled}>
              {/* @ts-ignore */}
              <Icon mr="8px" color="currentColor" boxSize="16px" />
              <span>{label}</span>
            </SplitButtonDropdownItem>
          );
        })}
      </SplitButtonDropdownContent>
    </SplitButton>
  );
};

type SplitButtonProps = {
  isSplitButton: true;
  disabled?: boolean;
  options: Array<{
    label: string;
    onClick: () => void;
    Icon?: React.FC;
    disabled?: boolean;
  }>;
  buttonLabel: string; // <- might be removed if we're using 0th index of options as button label, confirm with product & design
  StartIcon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
};

type ButtonProps = {
  isSplitButton: false;
  disabled?: boolean;
  onClick: () => void;
  label: string;
  Icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
};

type Props = SplitButtonProps | ButtonProps;

const AgGridActionButton = ({ isSplitButton, ...rest }: Props) => {
  if (isSplitButton) {
    const splitButtonProps = rest as SplitButtonProps;
    const { options, buttonLabel, disabled, StartIcon } = splitButtonProps;
    return <SplitButtonAgGrid options={options} buttonLabel={buttonLabel} disabled={disabled} StartIcon={StartIcon} />;
  }
  const buttonProps = rest as ButtonProps;
  const { label, disabled, onClick, Icon } = buttonProps;

  return (
    <Button iconLeft={Icon} onClick={onClick} disabled={disabled}>
      {label}
    </Button>
  );
};

export { AgGridActionButton };
